import { render } from "./videoComponent.vue?vue&type=template&id=e3423e18"
import script from "./videoComponent.vue?vue&type=script&lang=js"
export * from "./videoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__